import { Component, OnInit, OnDestroy, ViewEncapsulation, ViewChild, ViewChildren } from '@angular/core';
import { MenuItem } from '../../models/menu/menu.model';
import * as appConfig from '../../app.config';
import { ApiService } from '../../shared/services/api.service';
import { AlertService } from '../../shared/services/alert.service';
import { MenuService } from '../menu/services/menu.service';
import { TreeComponent } from '@circlon/angular-tree-component';
import { CommunicationService } from '../../shared/services/communication.service';

export const SUCCESS_MESSAGE = 'Menu bylo úspěšně uloženo!';
export const ERROR_MESSAGE = 'Při ukládání bohužel nastala chyba. Zkuste to prosím později.';

@Component({
  selector: 'swb-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None // TODO can we get rid of that?
})
export class MenuComponent implements OnInit, OnDestroy {

  private _usedInitialized = false;
  private _availableInitialized = false;
  @ViewChildren(TreeComponent)
  private trees: Array<TreeComponent>;

  public isInitialized = this._usedInitialized && this._availableInitialized;
  public treeAvailableNodes: any;
  public treeUsedNodes: any;
  public treeAvailableOptions: any;
  public treeUsedOptions: any;
  public allowedLevels = 1;
  public canDrop = false;
  public langs = appConfig.languages;
  public activeLangIndex = 0;
  public isSaving = false;

  constructor(
    private _menuService: MenuService,
    private _communicationService: CommunicationService,
    private _apiService: ApiService,
    private _alertService: AlertService
  ) { }

  ngOnInit() {
    this._setOptions();
    this._loadData();

    this._menuService.reloadRequested.subscribe(item => {
      this.treeAvailableNodes[item.lang].push(item);
      this.trees.forEach(tree => {
        tree.treeModel.update();
      });
    });

    this._communicationService.modalExecuted$.subscribe((id) => {
      this.langs.forEach(lang => {

        this.treeAvailableNodes[lang] = this.treeAvailableNodes[lang].filter((item: MenuItem) => item.id.toString() !== id);

      });
      this.trees.forEach(tree => {
        tree.treeModel.update();
      });

    });
  }

  ngOnDestroy() {
  }

  public switchTab(langIndex: number) {
    this.activeLangIndex = langIndex;
  }

  public save() {
    if (!this.isSaving) {
      this.isSaving = true;
      this._apiService.put(this.treeUsedNodes, 'menu/update').subscribe(
        (response: any) => {
          this.isSaving = false;
          if ({ ...response }.status <= 0) {
            this._alertService.error(ERROR_MESSAGE);
          } else {
            this._alertService.success(SUCCESS_MESSAGE);
          }
        },
        (error) => {
          this.isSaving = false;
          this._alertService.error(ERROR_MESSAGE);
        }
      );
    }
  }

  /**
   * Private method to get tree node depth
   * @param treeNode node to get depth of
   */
  private _getChildrenDepth(treeNode): number {
    let depth = 0;

    if (treeNode) {
      if (treeNode.hasChildren && treeNode.children) {
        depth = 1 + this._incrementDepth(treeNode.children);
      }
    }

    return depth;
  }

  /**
   * Private method to count tree node children recursively
   * @param children child nodes
   */
  private _incrementDepth(children: Array<any>): number {
    let i = 0;
    children.forEach(child => {
      if (child.children) {
        i = 1 + this._incrementDepth(child.children);
      }
    });

    return i;
  }


  public onMoveNode(e: any, onAvailable: boolean): void {

    if (onAvailable) {
      this.treeAvailableNodes[this.langs[this.activeLangIndex]] = this._flatten(this.treeAvailableNodes[this.langs[this.activeLangIndex]]);
    }

  }

  private _flatten(nodes: Array<MenuItem>): Array<MenuItem> {
    let flattenedNodes: Array<MenuItem> = [];
    nodes.forEach((node) => {
      let children = [];
      if (node.children) {
        children = node.children;
        node.children = [];
      }
      flattenedNodes.push(node);
      if (node.children) {
        flattenedNodes = flattenedNodes.concat(this._flatten(children));
      }
    });
    return flattenedNodes;
  }

  private _setOptions(): void {
    this.treeAvailableOptions = {
      allowDrag: true,
      allowDrop: (element, { parent, index }) => {
        return true;
      },
      animateExpand: true
    };

    this.treeUsedOptions = {
      allowDrag: true,
      allowDrop: (element, { parent, index }) => {
        const nodeDepth = this._getChildrenDepth(element);
        return (parent.level + nodeDepth < this.allowedLevels);
      },
      animateExpand: true
    };
  }

  private _loadData(): void {
    this._apiService.get('menu/used')
      .subscribe(
        (used: any) => {
          this.treeUsedNodes = used.data;
          this._usedInitialized = true;
          this.isInitialized = this._availableInitialized;
          this._apiService.get('menu/available')
            .subscribe(
              (response: any) => {
                const availableItems: MenuItem[] = [];
                appConfig.languages.forEach((lang) => {
                  availableItems[lang] = [];
                  const res = { ...response };
                  res.data[lang]?.forEach((item, i) => {
                    availableItems[lang].push(res.data[lang][i]);
                  });
                });

                this.treeAvailableNodes = availableItems;
                this._availableInitialized = true;
                this.isInitialized = this._usedInitialized;
              },
              (error) => console.error(error)
            );
        },
        (error) => console.error(error)
      );

  }

}
